// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e4bcb9fe","796":"97334766"}[chunkId] + ".chunk.js";
};